export default __webpack_public_path__ + "static/media/(17).ad44cfe1.jpg";